<template>
  <div class="exam-view">
    <!-- 题目类型 -->
    <div class="question-type">
      <span>{{type|typeText}}</span>
      <div class="bg ta--border-top-primary ta--border-left-primary"></div>
    </div>
    <!-- 题目控制 -->
    <div class="question-count ta--text-primary" style="cursor: pointer" @click="showQuestionStatus = true">
      <i class="icon mdi mdi-apps ta--text-primary"></i>
      <span>{{currentIndex + 1}}/{{allQuestion.length}}</span>
    </div>
    <!-- 题目区域 -->
      <div
        class="question-container"
      >
      <div class="question">
				<div class='type ta--bg-primary'>{{type|typeText}}</div>
        <p v-for="p in question.split('\n')" v-html="p.trim()"></p>
        <div class="ques-img-container" v-if="questionPicSrc.length">
          <img :src="src" v-for="src in questionPicSrc">
        </div>
      </div>
      <div class="answers" v-if="type != 4">
        <div class="answer-item" v-for="ans in answer" v-if="ans.text != ''">
          <template v-if="ans.select">
            <i v-if="correct" class="icon mdi mdi-checkbox-marked-circle ta--text-success"></i>
            <i v-else class="icon mdi mdi-close-circle wrong ta--text-warning"></i>
          </template>
          <i v-else class="icon mdi disabled mdi-checkbox-blank-circle-outline"></i>
          <div class="answer-main" v-html="ans.text"></div>
          <i v-if="ans.correct && !ignoreAnswer" class="correct mdi mdi-check ta--text-primary"></i>
        </div>
      </div>


      <div class="sub-ques-container" v-else>
        <div class="sub-ques-item" v-for="(subItem, subIndex) in subQues">
          <div class="sub-cutline">
            <div class="ques-type">{{subItem.type|typeText}}</div>
          </div>
          <div class="title">
            <p v-for="p in subItem.title.split('\n')" v-html="p"></p>
          </div>
          <img class="sub-pic" v-if="subItem.attachs" :src="`/m/p/quiz/attachs/${$route.query.crpId}/${subItem.id}/${subItem.attachs.split('/')[0]}`">
          <div class="sub-answers">
            <div class="sub-answer-item" v-for="sa in subAnswer[subIndex]" v-if="sa.text != ''">
              <template v-if="sa.select">
                <i v-if="sa.subCorrect" class="icon mdi selected mdi-checkbox-marked-circle ta--text-success"></i>
                <i v-else class="icon mdi wrong mdi-close-circle ta--text-warning"></i>
              </template>
              <i v-else class="icon mdi disabled mdi-checkbox-blank-circle-outline"></i>
              <span class="sub-ans-main" v-html="sa.text"></span>
              <i v-if="sa.correct && !ignoreAnswer" class="correct mdi mdi-check ta--text-primary"></i>
            </div>
          </div>
          <div class="analysis" v-if="analysesHash[subItem.id] && !ignoreAnswer">
            <p><strong>解析：</strong><span v-html="analysesHash[subItem.id]"></span></p>
          </div>
        </div>
      </div>

      <div class="analysis" v-if="analysesHash[questionSource.id] && !ignoreAnswer">
        <p><strong>解析：</strong><span v-html="analysesHash[questionSource.id]"></span></p>
      </div>


    </div>
    <!-- 答题状态 -->
    <transition name="fade-in">
      <div class="question-status-modal" v-show="showQuestionStatus" style="cursor: pointer" @click="showQuestionStatus = false"></div>
    </transition>
    <transition name="slide-fade">
      <div class="question-status-container" v-show="showQuestionStatus">
        <div class="question-status-panel">
          <div class="question-group" v-for="group in questionStatus">
            <div class="title">{{group.title}}</div>
            <div class="status-center">
              <div class="status-group">
                <div
                  v-for="(item, i) in group.status"
                  :class="[
                  'status-item',
                  item.correct == 'showNum' ?
                    '':
                     item.correct ?
                      'success ta--border-all-success ta--bg-success' : 'wrong ta--border-all-warning ta--bg-warning']">
                  <div class="status-btn" style="cursor: pointer" @click="tapQuestion(item.index)">
                    <span v-if="item.correct == 'showNum'">{{item.index + 1}}</span>
                    <i v-else-if="item.correct" class="mdi mdi-check"></i>
                    <i v-else class="mdi mdi-close"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hide-status-container" style="cursor: pointer" @click="showQuestionStatus = false">
            <div class="hide-status-btn">
              <i class="mdi mdi-chevron-up"></i>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 操作区域 -->
    <div class="active-bar">
      <div class="control-item" style="cursor: pointer" @click="prevQuestion">
        上一题
      </div>
      <div class="exam-score ta--text-primary" v-if="!ignoreScore">
        得分：{{score}}
      </div>
      <div class="control-item" style="cursor: pointer" @click="nextQuestion">
        下一题
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ExamView",
    data() {
      return {
        showQuestionStatus: false,
        allQuestion: [],
        questionGroup: [],
        questionPicSrc: [],
        questionSource: {},
        analysesHash: {},
        currentIndex: 0,
        type: '',
        question: '',
        answer: [],
        questionStatus: [],
        isExam: true,
        score: 0,
        correct: false,
        ignoreScore: false,
        ignoreAnswer: false,
        correctAnswers: {},
        subQues: [],
        subIndex: 0,
        subAnswer: [],
        logs: {},
        panelHeight: 160,
      }
    },
    beforeMount() {
      if(sessionStorage.getItem('ignoreExamInfo')){
        this.ignoreScore = true
      }
      if(sessionStorage.getItem('ignoreAnswer')) {
        this.ignoreAnswer = true
      }
      let {clazzId, crpId} = this.$route.query
      this.$axios.get(`/m/home/my/quiz/result/${crpId}/${clazzId}`)
        .then(resp => {
          let data = resp.data
          if(data){
            switch (data.status) {
              case 'ok':
                let m = data.message
                // console.log(m)
                /* 更改title */
                document.title = this.$store.state.examTitle
                this.$store.commit('changeNav', this.$store.state.examTitle)

                /* 提取解析 */
                if(m.analyses) {
                  this.analysesHash = m.analyses
                }

                /* 提取题目 */
                let aq = []
                let answers = m.answers || {}
                m.groups.forEach(g => {
                  let c = this.ignoreScore ? 'showNum' : false
                  aq = aq.concat(g.items.map(q => Object.assign({userAnswer: '', correct: c, cAnswer: answers[q.questionId]}, q.question)))
                })
                /* 初始化已经作答的题目 */
                let logs = m.itemLogs || {}
                aq.forEach((q, index) => {
                  if(q.type != 4){
                    if(logs[q.id]){
                      q.userAnswer = logs[q.id].answer.split(',').join('')
                      q.correct = logs[q.id].correct
                    }
                  } else {
                    let ans = {}
                    q.subQues.forEach(sq => {
                      if(logs[sq.id]){
                        ans[sq.id] = logs[sq.id].answer.split(',').join('')
                      } else {
                        ans[sq.id] = ''
                      }
                    })
                    q.userAnswer = ans
                    q.correct = (q.subQues.length == q.subQues.filter(sq => logs[sq.id] && logs[sq.id].correct).length)
                  }
                  q.qIndex = index
                })
                if (m.answers) {
                  this.correctAnswers = m.answers
                }

                if(m.itemLogs){
                  this.logs = m.itemLogs
                }
                /* 初始化答题组合 */
                let questionOffset = 0
                this.questionGroup = m.groups.map(g => {
                  let offset = questionOffset
                  questionOffset += g.items.length
                  return {
                    title: g.title,
                    type: g.questionType,
                    questionOffset: offset,
                    questionLength: g.items.length
                  }
                })

                this.allQuestion = aq

                /* 设置分数 */
                this.score = m.log.score

                /* 设置第一题 */
                this.setQuestion(0)

                this.formatAnswers()

                break
              case 'err':
                this.$toast(data.message)
                this.$router.go(-1)
                break
            }
          } else {
            this.$toast('获取数据失败')
          }
        })
    },
    watch: {
      type(val, oldVal) {
        if(val !== oldVal){
          this.panelHeight = 160
        }
      },
    },
    methods: {
      touchSub(e) {
        e.preventDefault()
        let height = document.documentElement.clientHeight - e.touches[0].clientY - 60
        if(height < 160) {
          height = 160
        }
        if(height > document.documentElement.clientHeight - 150){
          height = document.documentElement.clientHeight - 150
        }
        this.panelHeight = height
      },
      subPrev() {
        if(this.subIndex > 0){
          this.subIndex = this.subIndex - 1
          this.setSubAnswer()
        } else {
          this.prevQuestion()
        }
      },
      subNext() {
        if(this.subIndex < this.subQues.length - 1){
          this.subIndex = this.subIndex + 1
          this.setSubAnswer()
        } else {
          this.nextQuestion()
        }
      },

      setSubAnswer() {
        this.subAnswer = this.subQues.map(sq => {
          switch(sq.type){
            case 1:
            case 3:
              return [
              {
                  text: sq.opt1 || '',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id].indexOf('1') > -1,
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id].indexOf('1') > -1
              },
              {
                  text: sq.opt2 || '',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id].indexOf('2') > -1,
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id].indexOf('2') > -1
              },
              {
                  text: sq.opt3 || '',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id].indexOf('3') > -1,
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id].indexOf('3') > -1
              },
              {
                  text: sq.opt4 || '',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id].indexOf('4') > -1,
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id].indexOf('4') > -1
              },
              {
                  text: sq.opt5 || '',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id].indexOf('5') > -1,
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id].indexOf('5') > -1
              },
              {
                  text: sq.opt6 || '',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id].indexOf('6') > -1,
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id].indexOf('6') > -1
              },
            ]
            break
          case 2:
              return [
              {
                text: '正确',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id] == '1',
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id] == '1'
              },
              {
                text: '错误',
                  select: this.allQuestion[this.currentIndex].userAnswer[sq.id] == '0',
                  subCorrect: this.logs[sq.id] && this.logs[sq.id].correct,
                  correct: this.correctAnswers[sq.id] && this.correctAnswers[sq.id] == '0'
              },
            ]
            break
        }
        })
        // console.log(this.subQues)
        // console.log(this.subAnswer)

      },
      setQuestion(index){
        this.currentIndex = index
        //TODO: 重构时只使用 source 做元数据
        this.questionSource = this.allQuestion[index]
        this.type = this.allQuestion[index].type
        this.question = this.allQuestion[index].title
        this.correct = this.allQuestion[index].correct
        window.scrollTo(0,0)
        if(this.allQuestion[index].attachs){
          /* 处理试题图片 */
          let picArr = []
          this.allQuestion[index].attachs.split(',').forEach(attach => {
            picArr.push(`/m/p/quiz/attachs/${this.$route.query.crpId}/${this.allQuestion[index].id}/${attach.split('/')[0]}`)
          })
          this.questionPicSrc = picArr
        } else {
          this.questionPicSrc = []
        }
        // console.log(this.allQuestion[index])
        //TODO: 修改答案列表
        switch(this.type){
          case 1:
          case 3:
            this.answer = [
              {
                text: this.allQuestion[index].opt1 || '',
                select: this.allQuestion[index].userAnswer.indexOf('1') > -1,
                correct: this.allQuestion[index].cAnswer && this.allQuestion[index].cAnswer.indexOf('1') > -1
              },
              {
                text: this.allQuestion[index].opt2 || '',
                select: this.allQuestion[index].userAnswer.indexOf('2') > -1,
                correct: this.allQuestion[index].cAnswer && this.allQuestion[index].cAnswer.indexOf('2') > -1
              },
              {
                text: this.allQuestion[index].opt3 || '',
                select: this.allQuestion[index].userAnswer.indexOf('3') > -1,
                correct: this.allQuestion[index].cAnswer && this.allQuestion[index].cAnswer.indexOf('3') > -1
              },
              {
                text: this.allQuestion[index].opt4 || '',
                select: this.allQuestion[index].userAnswer.indexOf('4') > -1,
                correct: this.allQuestion[index].cAnswer && this.allQuestion[index].cAnswer.indexOf('4') > -1
              },
              {
                text: this.allQuestion[index].opt5 || '',
                select: this.allQuestion[index].userAnswer.indexOf('5') > -1,
                correct: this.allQuestion[index].cAnswer && this.allQuestion[index].cAnswer.indexOf('5') > -1
              },
              {
                text: this.allQuestion[index].opt6 || '',
                select: this.allQuestion[index].userAnswer.indexOf('6') > -1,
                correct: this.allQuestion[index].cAnswer && this.allQuestion[index].cAnswer.indexOf('6') > -1
              },
            ]
            break
          case 2:
            this.answer = [
              {
                text: '正确',
                select: this.allQuestion[index].userAnswer == '1',
                correct: this.allQuestion[index].cAnswer == '1'
              },
              {
                text: '错误',
                select: this.allQuestion[index].userAnswer == '0',
                correct: this.allQuestion[index].cAnswer == '0'
              },
            ]
            break
          case 4:
            this.subQues = this.allQuestion[index].subQues
            this.subIndex = 0
            this.subIndex = 0
            this.setSubAnswer()
            // this.panelHeight = 160
            break
        }
      },
      tapQuestion(index){
        /* 跳转到目标题目 */
        this.showQuestionStatus = false
        this.setQuestion(index)
      },
      prevQuestion(){
        if(this.currentIndex > 0){
          this.setQuestion(this.currentIndex - 1)
        } else {
          this.$toast('已经是第一题')
        }
      },
      nextQuestion(){
        if(this.currentIndex < this.allQuestion.length - 1){
          this.setQuestion(this.currentIndex + 1)
        } else {
          this.$toast('已经是最后一题')
        }
      },
      formatAnswers() {
        /* 格式化答案 */
        let qStatus = this.questionGroup.map(
          qg => Object.assign(
            {
              status: this.allQuestion.slice(qg.questionOffset, qg.questionOffset + qg.questionLength).map(q => {
                return {
                  index: q.qIndex,
                  answer: q.userAnswer,
                  correct: q.correct,
                }
              })
            },
            qg))
        this.questionStatus = qStatus
      },
    },
    filters: {
      typeText(type) {
        switch(type){
          case 1:
            return '单选'
          case 2:
            return '判断'
          case 3:
            return '多选'
          case 4:
            return '案例'
        }
      }
    }

  }
</script>

<style lang="scss" scoped>
  .exam-view {
    min-height: 100%;
    background: #fff;
    box-sizing: border-box;
		padding-bottom: 80px !important;
    .question-type {
      position: fixed;
      top: 64px;
      left: 2px;
      color: #fff;
      font-size: 11px;
      line-height: 30px;
      z-index: 100;
      .bg {
        width: 0;
        height: 0;
        border: 24px solid $primary;
        border-color: var(--primary);
        position: absolute;
        top: 0;
        left: -2px;
        z-index: -1;
        border-bottom-color: transparent;
        border-right-color: transparent;
      }
    }
    .question-count {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 64px;
      left: 0;
			font-size: 16px;
      color: $primary;
      color: var(--primary);
      vertical-align: middle;
      background: #fff;
      .icon {
        font-size: 16px;
        color: $primary;
        color: var(--primary);
        margin-right: 5px;
      }

    }
    .question-container {
      min-height: 200px;
      padding: 45px 25px;
      text-align: left;
			max-width: 800px;
      margin: 0 auto;
      .analysis {
        padding: 15px;
        background: #F5F5F5;
        font-size: 15px;
        margin-top: 30px;
      }
      .question {
				.type {
					background: $primary;
					background: var(--primary);
					color: #fff;
					width: 60px;
					font-size: 18px;
					line-height: 28px;
					text-align: center;
					border-radius: 5px;
					margin-bottom: 5px;
				}
        p {
					font-size: 24px;
					margin-bottom: 10px;
        }
        .ques-img-container {
          margin-top: 15px;
          img {
            max-width: 100%;
            height: auto;
            & + img {
              margin-top: 10px
            }
          }
        }
      }
      .answer-item {
        display: flex;
        margin-top: 32px;
				font-size: 20px;
        .icon {
          font-size: 21px;
					line-height: 26px;
          height: 26px;
          margin-right: 20px;
          color: $success;
          color: var(--success);
          &.wrong {
            color: $warning;
            color: var(--warning);
          }
          &.disabled {
            color: #C7C7CD;
          }
        }
        .answer-main {
          flex-grow: 1;
        }
        .correct {
          margin-left: 5px;
          font-size: 20px;
          color: $primary;
          color: var(--primary);
          flex-shrink: 0;
        }
      }

      .sub-ques-container {
        background: #fff;
        width: 100%;
        box-sizing: border-box;
        .sub-ques-item {
          margin-top: 25px;
          box-sizing: border-box;
          .sub-cutline {
            border-bottom: 1px solid $primary;
            margin-bottom: 16px;
            .ques-type {
              font-size: 16px;
              line-height: 28px;
              background: $primary;
              color: #fff;
              width: 56px;
              text-align: center;
              border-radius:4px 4px 0px 0px;
            }
          }
          .sub-question-type {
            position: absolute;
            top: 0;
            left: 2px;
            color: #fff;
            font-size: 11px;
            line-height: 30px;
            z-index: 100;
            .bg {
              width: 0;
              height: 0;
              border: 24px solid $primary;
              border-color: var(--primary);
              position: absolute;
              top: 0;
              left: -2px;
              z-index: -1;
              border-bottom-color: transparent;
              border-right-color: transparent;
            }
          }
          .title {
						font-size: 24px;
            margin-bottom: 5px;
            .ques-type {
              font-size: 12px;
              line-height: 1;
              padding: 2px 5px;
              background: $primary;
              color: #fff;
              margin-right: 10px;
            }
          }
          .sub-pic {
            max-width: 100%;
            height: auto;
            margin-top: 15px;
          }
          .sub-answers {
            .sub-answer-item {
              display: flex;
							font-size: 20px;
              margin-top: 20px;
              .mdi {
                font-size: 21px;
								line-height: 26px;
								height: 26px;
                margin-right: 20px;
                color: #C7C7CD;
                &.selected {
                  color: $success;
                  color: var(--success);
                }
                &.wrong {
                  color: $warning;
                  color: var(--warning);
                }
              }
              .sub-ans-main {
                flex-grow: 1;
              }
              .correct {
                margin-left: 5px;
                margin-right: 0;
                font-size: 20px;
                color: $primary;
                color: var(--primary);
                flex-shrink: 0;
              }
            }
          }
        }

      }
    }
    .question-status-modal {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      z-index: 1000;
      background: rgba(0,0,0,.48);
    }
    .question-status-container {
      position: fixed;
      bottom: 150px;
      left: 0;
      right: 0;
      top: 0;
      z-index: 1001;
      .question-status-panel {
        background: #fff;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        padding: 25px;
        .question-group {
          .title {
            font-size: 14px;
            line-height: 1;
            margin-bottom: 15px;
            text-align: left;
          }
          .status-center {
            max-width: 340px;
            margin: 0 auto;
            margin-bottom: 10px;
            @media screen and (max-width: 370px) {
              max-width: 300px;
            }
            @media screen and (max-width: 350px) {
              max-width: 237px;
            }
          }
          .status-group {
            overflow: hidden;
            max-width: 340px;
            margin-right: -20px;
            .status-item {
              width: 46px;
              height: 46px;
              float: left;
              margin-right: 20px;
              margin-bottom: 15px;
              border: 1px solid #999;
              border-radius: 50px;
              line-height: 48px;
              text-align: center;
              &.success {
                color: #fff;
                border-color: $success;
                border-color: var(--success);
                background: $success;
                background: var(--success);
              }
              &.wrong {
                color: #fff;
                border-color: $warning;
                border-color: var(--warning);
                background: $warning;
                background: var(--warning);
              }
            }
            @media screen and (max-width: 370px) {
              max-width: 315px;
              margin-right: -15px;
              .status-item {
                margin-right: 15px;
              }
            }
            @media screen and (max-width: 350px) {
              max-width: 252px;
            }
          }
        }
        .hide-status-container {
          width: 100%;
          height: 25px;
          background-color: rgba(255,255,255,.1);
          position: absolute;
          left: 0;
          bottom: 0;
          .hide-status-btn {
            width: 60px;
            height: 16px;
            background: #ECEDED;
            position: absolute;
            bottom: 0;
            left: 50%;
            margin-left: -30px;
            border-radius: 8px 8px 0 0;
            .mdi {
              font-size: 16px;
              color: #666666;
            }
          }

        }
      }
    }
    .active-bar {
      width: 100%;
      box-sizing: border-box;
      height: 68px;
      position: fixed;
      bottom: 0;
      left: 0;
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #DBDBDB;
			padding: 0 40px;
			font-size: 20px;
      .exam-score {
        font-size: 20px;
        color: $primary;
        color: var(--primary);
      }

    }
  }


  /* 展开动画 */
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.3s linear;
    max-height: 500px;
    overflow: hidden;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    max-height: 0;
    overflow: hidden;
  }
  .fade-in-enter-active,
  .fade-in-leave-active {
    transition: all 0.3s linear;
    opacity: 1;
  }
  .fade-in-enter,
  .fade-in-leave-to {
    opacity: 0;
  }
</style>
